import React from 'react';
import { get } from 'lodash';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import Main from './partials/Main';
import {
  LogIn,
  SignUp,
  ResetPassword,
  ForgotPassword,
  Dashboard,
  ApplicationForm,
  ResubmitApplicationForm,
  ContainerProfile,
  ContainerAppointment,
  ContainerTransactionHistory,
  ViewApplication,
  ReviewUploadedDocuments,
  Contact,
  Guideline,
  ProvisionalAuthority,
  GuidelinePublic,
  Otp,
  ForgotPasswordOtp,
  ResetPasswordOtp } from './containers/index';

import { useSelect } from './hooks/index';

const routes = [
  {

    exact: true,
    path: '/',
    component: GuidelinePublic,
    isPrivate: false
  },
  {
    exact: true,
    path: '/login',
    component: LogIn,
    isPrivate: false
  },
  {
    exact: true,
    path: '/otp',
    component: Otp,
    isPrivate: false
  },
  {
    exact: true,
    path: '/sign-up',
    component: SignUp,
    isPrivate: false
  },
  {
    exact: true,
    path: '/forgot-password',
    component: ForgotPasswordOtp,
    isPrivate: false
  },
  {
    exact: true,
    path: '/reset-password',
    component: ResetPasswordOtp,
    isPrivate: false
  },
  {
    path: '/pdf',
    component: ProvisionalAuthority,
    isPrivate: false
  },

  {
    path: '/',
    component: Main,
    isPrivate: true,
    routes: [
      {
        exact: true,
        path: '/',
        component: Dashboard,
        routes: [
          {
            path: '/',
            component: ContainerTransactionHistory
          }
        ]
      },
      {
        path: '/application/:id/view',
        component: ViewApplication,
      },
      {
        path: '/application/:id/resubmit',
        component: ResubmitApplicationForm,
      },
      {
        path: '/application/:id/document',
        component: ReviewUploadedDocuments
      },
      {
        path: '/application/:id/appointment',
        component: Dashboard,
        routes: [
          {
            path: '/application/:id/appointment',
            component: ContainerAppointment
          }
        ]
      },
      {
        path: '/profile',
        component: ContainerProfile,
      },
      {
        path: '/contact',
        component: Contact
      },
      {
        path: '/guideline',
        component: Guideline
      },
      {
        path: '/application-form',
        component: ApplicationForm
      }
    ]
  }
];

export const RouteWithSubRoutes = (route) => {
  return (
    <Route
      exact={route.exact}
      path={route.path}
      render={props => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

const Routers = () => {

  const isAuthenticated = useSelect('auth.isAuthenticated')

  return (
    <Router>
      <Switch>
        {routes.filter(x => get(x, 'isPrivate') === isAuthenticated).map(route => {
          return (
            <RouteWithSubRoutes key={`rootRoutes${get(route, 'path')}`} {...route}/>
          )
        })}
      </Switch>
    </Router>
  )
}

export default Routers
